module.exports = __webpack_public_path__ + "jtails-build/img/1@2.f1439c62.jpg";